import { useState, useRef, useMemo } from "react";
import { useAppConfigurationSelector } from "../../../redux/reducers/AppConfigurationReducer/AppConfigurationReducer";
import { useDispatch } from "react-redux";
import { openModal } from "../../../redux/reducers/ModalReducer/ModalReducer";
import { CompareModule } from "../../../modules/Compare.module";
import { setUserPerm, usePermissionsSelector } from "../../../redux/reducers/Permissions/PermissionsReducer";
import { patchUserCookiesPerm } from "../../../apis/Permissions/PermissionsApi";
import { useClarity } from "../../../hook/useClarity";
import { useTrack } from "../../../hook/useTrack";
import { IQueryName } from "../../../interfaces/IQueryName/IQueryName";
import { IQueueType } from "../../../interfaces/IQueueType";
export const useCookiesLogic = () => {
    const dispatch = useDispatch();
    const { userPerm } = usePermissionsSelector("userPerm");
    const { appId } = useAppConfigurationSelector("appId");
    const { setCookie } = useClarity();
    const { trackItAsync2 } = useTrack();
    //const loaded = true
    const [cookieState, setCookieState] = useState({
        experience: userPerm.cookies?.experience || false,
        offer: userPerm.cookies?.offer || false
    });
    const originalState = useRef({ ...cookieState });
    const onChange = (type) => () => {
        setCookieState((prev) => ({ ...prev, [type]: !prev[type] }));
    };
    const onClose = () => {
        dispatch(openModal(undefined));
    };
    const save = async (acceptAll = false) => {
        // appeler une mutation pour patch la config
        //deplacer le infoReducer dan le packages front
        const permUpdate = {
            ...userPerm,
            cookies: acceptAll ? { experience: true, offer: true } : cookieState
        };
        await trackItAsync2(IQueryName.SAVE_COOKIES, patchUserCookiesPerm, IQueueType.TrackLead, { cookies: { experience: permUpdate.cookies?.experience, offer: permUpdate.cookies?.offer } })(appId, permUpdate);
        dispatch(setUserPerm(permUpdate));
        if (cookieState.Experience != originalState.current.Experience) {
            setCookie("clarity_consent", cookieState.Experience.toString());
        }
        onClose();
    };
    const compareState = useMemo(() => {
        return CompareModule.areObjectsEqual(cookieState, originalState.current);
    }, [cookieState, originalState]);
    return { cookieState, onChange, onClose, save, compareState };
};
